/**
 * @generated SignedSource<<34d74f620375fe40e1eed2351515c90e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightListLastPriceChange_flight$data = {
  readonly createdAt: string | null;
  readonly lastPriceChange: string;
  readonly lastPriceChangeDays: number;
  readonly " $fragmentType": "FlightListLastPriceChange_flight";
};
export type FlightListLastPriceChange_flight$key = {
  readonly " $data"?: FlightListLastPriceChange_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightListLastPriceChange_flight">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightListLastPriceChange_flight",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastPriceChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastPriceChangeDays",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "type": "Flight",
  "abstractKey": null
};

(node as any).hash = "33f990f33d21b1719197230b501ce6c2";

export default node;
